import axios from 'axios';
import Cookies from 'js-cookie';

const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_GATEWAY_URL,
  headers: {
    'Content-Type': 'application/json'
  }
});

axiosInstance.interceptors.request.use(
  (config) => {
    const token = Cookies.get('token');

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

axiosInstance.interceptors.response.use(
  (response) => response.data,
  (error) => {
    if (error.response && error.response.status === 401) {
      const hadToken = Cookies.get('token');

      if (hadToken) {
        // User was logged in but token is now invalid - redirect to login
        Cookies.remove('token');
        localStorage.clear();
        window.location.href = `/authen/login?from=${window.location.href}`;
      }
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;
